import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { OutletId } from '@/shared/models/Outlet';
import Indicator from '../models/Indicator';

const SCHEMA = {
  ...BASE_SCHEMA,
  description: 'description',
  isActive: 'isActive',
  colorHex: 'colorHex',
  isFixedTimeslot: 'isFixedTimeslot',
  isCompetence: 'isCompetence',
  dailyCapacity: 'dailyCapacity',
};

export function parseIndicator(data: any, outletId: OutletId): Indicator | null {
  const indicator = parseEntity(data, SCHEMA, Indicator);
  if (indicator) indicator.outletId = outletId;
  return indicator;
}

export function parseIndicators(data: any, outletId: OutletId): Array<Indicator> {
  return parseEntities(data, d => parseIndicator(d, outletId));
}